import type { RouteObject } from 'react-router-dom'
import cloneDeepWith from 'lodash/cloneDeepWith'
import { isValidElement } from 'react'

export const filterPermissionPages = (asyncRoutes: RouteObject[], permissions: any) => {
  const filter = (path = '') => {
    const arr = path.split('/')
    const moduleName = arr[0]
    if (!moduleName) return false
    const pages = permissions[moduleName]

    // 通过拼接字符串查找，比如 /user/bank/:cardId 查找 /user/bank/*
    let str = moduleName
    let i = 1
    let flag = false

    while (i < arr.length) {
      str += '/' + arr[i]
      if (pages.includes(str + '/*')) {
        flag = true
        break
      }
      i++
    }
    if (flag) return true

    return pages && pages.includes(path)
  }

  const iterate = (routes: any, path = '') => {
    if (path && path.indexOf('/') === 0) {
      path = path.slice(1)
    }

    return routes.reduce((acc: any, curr: any) => {
      let currPath = ''

      if (path) {
        currPath = curr.path ? path + '/' + curr.path : path
      } else {
        currPath = curr.path.slice(1)
      }

      if (filter(currPath)) {
        if (curr.children && curr.children.length) {
          curr.children = iterate(curr.children, currPath)
        }
        acc.push(curr)
      }
      return acc
    }, [])
  }

  const cloneRoutes = cloneDeepWith(asyncRoutes, value => {
    if (isValidElement(value)) {
      return value
    }
  })

  return iterate(cloneRoutes)
}
